<div
  class="bg-gray-500 bg-opacity-60 w-screen h-screen fixed flex justify-center items-baseline top-0 left-0 z-50 pb-[100px] overflow-auto pt-6"
  (mousedown)="outOfDialogClick($event)">
  <div class="rounded bg-white h-fit px-10 py-6 min-w-[350px] md:min-w-[700px] shadow-lg mt-10 relative"
       [style.max-width.%]="maxWidth" @popInOut>
    <div class="flex justify-between pb-4 text-color-sun-yellow">
      <h4>{{title}}</h4>
      <i class="pvsc-icon icon-close absolute top-6 right-6 text-xl cursor-pointer" (click)="closeClicked.emit()"></i>
    </div>
    <div *ngIf="title" class="mb-3">
      <psc-line></psc-line>
    </div>
    <div>
      <ng-content></ng-content>
    </div>
  </div>
</div>
